const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Workshop Host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('multiSessionWorkshopHost', ['Application', 'Authorization', 'MultiSessionWorkshops', 'Ratings', 'Analyze', '$q', '$translate', function (Application, Authorization, MultiSessionWorkshops, Ratings, Analyze, $q, $translate) {
    return {
        restrict: 'E',
        scope: {},
        template: require('../../templates/directives/multi-session-workshop-host.html'),
        controller: ['$scope', function ($scope) {
            var self = this;
            var routeParameters = Application.navigation.getRouteParameters();
            self.user = Authorization.getAuthToken().user;

            self.reporting = {
                allSelected: false,
                selectionSessionIDs: [],
                selections: [],
                activeLink: '',
                allDateIDs: [],
                allDateLink: '',
                select: function(item) {
                    var idx = self.reporting.selectionSessionIDs.indexOf(item.id);
                    if (idx === -1) {
                        self.reporting.selectionSessionIDs.push(item.id);
                        self.reporting.selections.push(item);
                        self.reporting.setLink();
                        return;
                    }
                    self.reporting.selections.splice(idx, 1);
                    self.reporting.selectionSessionIDs.splice(idx, 1);
                    self.reporting.setLink();
                },
                setLink: function() {
                    if (self.reporting.selections.length || self.reporting.allSelected || self.reporting.selectionSessionIDs.length) {
                        let instances = [];
                        self.reporting.selections.forEach((session) => {
                            session.instances.forEach((instance) => {
                                instances.push(instance.id);
                            })
                        });
                        instances = instances.join(',');
                        if (self.reporting.allSelected) {
                            instances = [];
                            self.sessions.list.forEach(function(session) {
                                session.instances.forEach(function(instance) {
                                    if (instance.id) {
                                        instances.push(instance.id);
                                    }
                                });
                            });
                            instances = instances.join(',');
                        }
                        self.reporting.activeLink = Application.API + '/learn/v3/workshops/report/' + routeParameters.id + '?authtoken=' + Authorization.getAuthToken().authtoken + '&instances=' + instances;
                        return;
                    }
                    self.reporting.activeLink = '';
                },
                linkClicked: function() {
                    self.reporting.clicked = true;
                    setTimeout(function() {
                        self.reporting.clicked = false;
                        $scope.$apply();
                    }, 5000);
                },
                isSelected: function(item) {
                    if (!item || !item.id) {
                        return false;
                    }
                    return self.reporting.allSelected || self.reporting.selections.indexOf(item._id) !== -1;
                }
            };

            self.info = {
                loading: false,
                totals: {
                    registered: 0,
                    sessions: 0,
                    attended: 0
                },
                averageRating: 0,
                sessionsInfo: {},
                showStats: function() {
                    return !!(self.info.totals.sessions || self.info.totals.registered);
                },
                viewSession: function(session) {
                    Application.navigation.goTo(`host/multi-session-workshop-sessions/${self.workshop.id}/session/${session.id}`)
                },
                goToWorkshop: function() {
                    Application.navigation.goTo('view/multi-session-workshops/' + self.workshop.id)
                },
                editWorkshop: function() {
                    Application.navigation.goTo('edit/multi-session-workshops/' + self.workshop.id)
                },
                requestDisable: function() {
                    if (self.workshop.registration_disabled) {
                        self.info.changeRegistration();
                        return;
                    }
                    self.info.registrationDisable = true;
                },
                changeRegistration: function() {
                    var action = self.workshop.registrationDisabled ? 'enable' : 'disable';
                    self.info.loading = true;
                    MultiSessionWorkshops.update({subresource: self.workshop.id, fields: 'registrationDisabled, autoPopulateFromWaitlist'}, {
                        registrationDisabled: action === 'disable' ? true : false,
                        autoPopulateFromWaitlist: action === 'disable' ? true : false
                    }).$promise
                        .then(function(data) {
                            self.info.registrationDisable = false;
                            Analyze.record({resource: 'modifications'}, {document: self.workshop.id, type: 'workshop'});
                            Application.analyticsProvider.trackEvent('workshop_updated', {content: self.workshop.id, type: 'workshop', title: self.workshop.name});
                            Application.messaging.addMessage({type: 'success', duration: 3, text: 'Registration ' + (action === 'disable' ? 'disabled' : 'enabled') + '.'});
                            self.workshop.registrationDisabled = data.registrationDisabled;
                            self.workshop.autoPopulateFromWaitlist = data.autoPopulateFromWaitlist;
                            self.info.loading = false;
                        }).catch(function(error) {
                        $translate('workshopHost.unable_to_save').then(function (translation) {
                            Application.messaging.addMessage({type: 'error', text: translation, duration: 5});
                        });
                        self.info.loading = false;
                    });
                }
            };

            self.sessions = {
                list: [],
                rangeTab: 'future',
                allSessionIds: [],
            };

            self.comms = {
                initializing: false,
                initialize: function() {
                    self.comms.initializing = true;
                    $q.all([
                        self.comms.getWorkshop()
                    ]).then(function(data) {
                        self.workshop = data[0];
                        self.sessions.list = self.workshop.sessions;
                        self.comms.getTotals(self.sessions.list);
                        self.comms.calculateAverageRating();
                        self.reporting.allDateIDs = self.reporting.allDateIDs.join(',');
                        self.reporting.allDateLink = Application.API + '/learn/v3/workshops/report/' + routeParameters.id + '?authtoken=' + Authorization.getAuthToken().authtoken + '&instances=' + self.reporting.allDateIDs;
                        if (self.workshop && self.workshop.sessions && self.workshop.sessions.length > 0) {
                            self.comms.initializing = false;
                            return;
                        }
                        self.info.noWorkshops = true;
                        self.comms.initializing = false;
                    }).catch(function(error) {
                        console.log('error: ', error)
                        self.comms.initializing = false;
                    });
                },
                getWorkshop: function() {
                    return MultiSessionWorkshops.findOne({subresource: routeParameters.id}).$promise;
                },
                getTotals: function(sessions) {
                    self.info.totals.sessions = sessions.length;
                    let registeredTotals = new Set();
                    let attendedTotals = new Set();
                    for (let session of sessions) {
                        self.info.sessionsInfo[session.id] = {};
                        self.sessions.allSessionIds.push(session.id);
                        let registeredSessionInfo = new Set();
                        let attendedSessionInfo = new Set();
                        let waitingSessionInfo = new Set();
                        for(let instance of session.instances){
                            //save all instance Ids for allDateLink
                            self.reporting.allDateIDs.push(instance.id)
                            for(let registration of instance.userRegistrations) {
                                if (registration.status === 'registered') {
                                    registeredTotals.add(registration.userId);
                                    registeredSessionInfo.add(registration.userId);
                                }
                                if (registration.status === 'attended') {
                                    attendedTotals.add(registration.userId);
                                    attendedSessionInfo.add(registration.userId);
                                }
                                if (registration.status === 'waiting') {
                                    waitingSessionInfo.add(registration.userId);
                                }
                            }
                        }
                        self.info.sessionsInfo[session.id].registered = registeredSessionInfo.size;
                        self.info.sessionsInfo[session.id].attended = attendedSessionInfo.size;
                        self.info.sessionsInfo[session.id].waiting = waitingSessionInfo.size;
                    }
                    self.info.totals.registered = registeredTotals.size;
                },
                calculateAverageRating: function() {
                    let totalRatings = 0;
                    let ratingCounter = 0;
                    const stringIds = self.sessions.allSessionIds.join(',');
                    const query = {
                        content_id: `$in,${self.sessions.allSessionIds.length},${stringIds}`,
                    }

                    Ratings.find(query).$promise.then(function(results) {
                        if(results.length) {
                            results.forEach((result) => {
                                if(result.rating) {
                                    ratingCounter ++;
                                    totalRatings += result.rating;
                                }
                            });
                        }
                        if (totalRatings && ratingCounter) {
                            self.info.averageRating = Math.ceil(totalRatings / ratingCounter);
                        }
                    });
                }
            };

            self.comms.initialize();

        }],
        controllerAs: 'host'
    }
}]);
